import { Box, css, styled } from '@mui/material';

import { styledCustom } from '/styles';

export const CustomPopover = styled(Box)`
  gap: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 8px 16px;
  border-radius: 8px;
  min-height: 60px;
`;
export const resetDefaultSetting = css`
  background-color: transparent;
  box-shadow: unset;
  padding: 0;
  cursor: pointer;
`;
export const SpanCursor = styledCustom('span')<{ disableHoverListener?: boolean }>(({ disableHoverListener }) => ({
  cursor: disableHoverListener ? 'inherit' : 'pointer',
}));
